import { Helmet, HelmetProvider } from "react-helmet-async";
import { Colors } from "./../../assets/styles/Colors";
import styled from "styled-components";
import Header from "./../../components/Header/Header";
import Contact from "./../../components/Contact/Contact";
import img from "./../../assets/images/homepage/section.webp";

export default function HomePage() {
  return (
    <HelmetProvider>
      <Helmet>
        <title>Majewscy3m.pl - strona główna</title>
      </Helmet>
      <Header title="Strona główna" color="green" />
      <Wrapper>
        <Section01>
          <ImgWrapper>
            <Img src={img} alt="kostka brukowa" />
          </ImgWrapper>
          <TextWrapper>
            <Heading>O nas</Heading>
            <p>
              Jesteśmy Firmą Rodzinną, która jako spółka prawa handlowego działa
              na rynku od stycznia 2017 roku - wcześniej, przez kilkanaście lat,
              zdobywaliśmy doświadczenie w ramach działalności gospodarczej.
            </p>
            <p>
              Zapraszamy do kontaktu - każde zlecenie zaczynamy od spotkania z
              Klientem celem dokonania bezpłatnych pomiarów i uzgodnienia
              warunków oraz przedstawienia (niezobowiązującego) wstępnego
              kosztorysu.
            </p>
          </TextWrapper>
        </Section01>
        <Section02>
          <Heading>Czym się zajmujemy</Heading>
          <p>
            Głównym przedmiotem działalności naszej firmy są kompleksowe usługi
            brukarskie. W naszej ofercie można znaleźć układanie kostki
            brukowej, a także granitowej. Podejmiemy się wykonania każdego
            zlecenia.
          </p>
        </Section02>
        {/* <Section03>
          <QuoteText>
            <QuoteIcon>"</QuoteIcon>Ponieważ jesteśmy w tym dobrzy
            <QuoteIcon>"</QuoteIcon>
          </QuoteText>
        </Section03> */}
        <Section04>
          <Heading>Dlaczego my</Heading>
          <Box>
            Zapewniamy wysoką jakość świadczonych usług z zachowaniem
            konkurencyjnych cen
          </Box>
          <Box>
            Nasza kadra pracownicza jest doświadczona oraz wykwalifikowana
          </Box>
          <Box>
            Dokładamy wszelkich starań, aby spełnić oczekiwania naszych klientów
          </Box>
        </Section04>
        <Contact color="green" />
      </Wrapper>
    </HelmetProvider>
  );
}

const Wrapper = styled.div`
  width: 90vw;
  margin: 5vw auto;

  @media (min-width: 576px) {
    width: 540px;
  }

  @media (min-width: 768px) {
    width: 720px;
    margin: 2.5vw auto;
  }

  @media (min-width: 992px) {
    width: 960px;
  }

  @media (min-width: 1200px) {
    width: 1140px;
  }

  @media (min-width: 1400px) {
    width: 1320px;
  }

  @media (min-width: 1600px) {
    width: 1540px;
  }
`;

const Section01 = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`;

const ImgWrapper = styled.div`
  width: 100%;

  @media (min-width: 768px) {
    width: 48%;
  }
`;

const Img = styled.img`
  width: 100%;
  height: auto;
  margin: 0 auto;
  display: block;
  border-radius: 4px;

  @media (min-width: 768px) {
    width: 100%;
  }
`;

const TextWrapper = styled.div`
  width: 100%;
  margin-top: 1rem;
  color: ${Colors.black};

  p {
    text-align: center;
  }

  p:first-of-type {
    margin-bottom: 1rem;
  }

  @media (min-width: 768px) {
    width: 48%;
    margin-top: 0;

    p {
      text-align: left;
    }
  }
`;

const Heading = styled.h2`
  position: relative;
  width: 100%;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  text-align: left;
  font-size: 2rem;
  font-weight: 800;
  color: ${Colors.lightBlack};

  &::before {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 50px;
    height: 5px;
    background-color: ${Colors.darkGreen};
  }

  @media (min-width: 768px) {
    font-size: 2.2rem;
  }
`;

const Section02 = styled.div`
  margin-top: 4rem;
  padding: 1rem;
  text-align: center;
  background-color: ${Colors.gray};
  border-radius: 4px;

  @media (min-width: 768px) {
    width: 70%;
    margin: 6rem 0 auto 0;
    text-align: left;
  }
`;

const Section03 = styled.div`
  margin-top: 2rem;
`;

const QuoteText = styled.h2`
  position: relative;
  margin-top: 4rem;
  display: flex;
  justify-content: center;
  text-transform: uppercase;
  text-align: center;
  font-size: 2rem;
  font-weight: 800;
  color: ${Colors.green};

  @media (min-width: 768px) {
    margin-top: 6rem;
    font-size: 2.2rem;
  }
`;

const QuoteIcon = styled.span`
  font-size: 2rem;
  font-weight: 800;
  color: ${Colors.lightBlack};
`;

const Section04 = styled.div`
  margin-top: 4rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;

  @media (min-width: 768px) {
    margin-top: 6rem;
  }
`;

const Box = styled.div`
  width: 100%;
  min-height: 150px;
  margin: 0.5rem 0;
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${Colors.green};
  color: ${Colors.white};
  text-align: center;
  font-weight: 500;
  border: 3px solid ${Colors.green};
  border-radius: 4px;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: ${Colors.white};
    color: ${Colors.green};
  }

  @media (min-width: 768px) {
    width: 32%;
  }
`;
